import React from 'react';

/**
 * Renderiza el bloque ComparisonSurface de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function ComparisonSurface({
  v
}) {
  return v.cIsSup ? React.createElement(React.Fragment, null, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.740741vh",
      "flexWrap": "wrap",
      "alignItems": "center"
    }
  }, v.text("\n          "), (v.cLeg || []).map((l, index156) => React.createElement(React.Fragment, {
    key: index156
  }, v.text("\n            "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "padding": "0.37037vh 0.555556vh 0.37037vh 0.925926vh",
      "borderRadius": "1.296296vh",
      "border": "0.092593vh solid " + l.c,
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "fontSize": "1.111111vh",
      "color": "#e4e9f0"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": l.c
    }
  }, null), v.text(l.lab), React.createElement("button", {
    "onClick": l.onRemove,
    style: {
      "border": "0",
      "background": "transparent",
      "color": "#8793a6",
      "cursor": "pointer",
      "fontSize": "1.203704vh",
      "padding": "0 0.37037vh",
      "lineHeight": "1"
    }
  }, v.text("×"))), v.text("\n          "))), v.text("\n          \n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh"
    }
  }, v.text("\n          "), (v.cPanels || []).map((p, index157) => React.createElement(React.Fragment, {
    key: index157
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.708333vw minmax(0,1fr)",
      "gap": "0.740741vh"
    }
  }, v.text("\n              "), React.createElement("div", {
    style: {
      "position": "relative",
      "height": p.h / 10.8 + "vh"
    }
  }, v.text("\n                "), (p.yt || []).map((t, index158) => React.createElement(React.Fragment, {
    key: index158
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "bottom": t.pos,
      "transform": "translateY(50%)",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text(t.lab)))), v.text("\n              ")), v.text("\n              "), React.createElement("div", {
    "onMouseMove": v.cMove,
    "onMouseLeave": v.cLeave,
    style: {
      "position": "relative",
      "height": p.h / 10.8 + "vh",
      "borderBottom": "0.092593vh solid #2a3446",
      "borderLeft": "0.052083vw solid rgba(46,179,238,0.12)",
      "cursor": "crosshair"
    }
  }, v.text("\n                "), (p.yt || []).map((t, index159) => React.createElement(React.Fragment, {
    key: index159
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "bottom": t.pos,
      "borderTop": "0.092593vh solid #151e2c"
    }
  }, null))), v.text("\n                "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0.416667vw",
      "top": "0.37037vh",
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "fontSize": "1.111111vh",
      "fontWeight": "600",
      "color": p.c,
      "pointerEvents": "none",
      "background": "rgba(8,18,32,0.9)",
      "padding": "0 0.37037vh",
      "borderRadius": "0.277778vh",
      "zIndex": "1"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": p.c
    }
  }, null), v.text(p.label)), v.text("\n                "), React.createElement("svg", {
    "viewBox": "0 0 1000 100",
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "visible"
    }
  }, v.text("\n                  "), (p.lines || []).map((l, index160) => React.createElement(React.Fragment, {
    key: index160
  }, React.createElement("path", {
    "d": l.d,
    "stroke": l.c,
    "strokeWidth": l.w,
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null))), v.text("\n                ")), v.text("\n                "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.cHx,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.6",
      "pointerEvents": "none",
      "display": v.cHd
    }
  }, null), v.text("\n                "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0.555556vh",
      "left": v.cHx,
      "transform": v.cTx,
      "minWidth": "8.854167vw",
      "background": "rgba(4,10,20,0.96)",
      "border": "0.092593vh solid " + p.c,
      "borderRadius": "0.740741vh",
      "padding": "0.555556vh 0.925926vh",
      "display": v.cHdf,
      "flexDirection": "column",
      "gap": "0.277778vh",
      "pointerEvents": "none",
      "zIndex": "3"
    }
  }, v.text("\n                  "), React.createElement("div", {
    style: {
      "font": "500 1.111111vh 'IBM Plex Mono',monospace",
      "color": p.c
    }
  }, v.text(v.cTipT)), v.text("\n                  "), (p.tip || []).map((r, index161) => React.createElement(React.Fragment, {
    key: index161
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "1.296296vh",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "color": "#b8c1ce"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": r.c
    }
  }, null), v.text(r.lab)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace"
    }
  }, v.text(r.val))))), v.text("\n                ")), v.text("\n              ")), v.text("\n            ")), v.text("\n          "))), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.708333vw minmax(0,1fr)",
      "gap": "0.740741vh",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text("\n          "), React.createElement("div", {}, null), v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between"
    }
  }, (v.cHours || []).map((h, index162) => React.createElement(React.Fragment, {
    key: index162
  }, React.createElement("span", {}, v.text(h.lab))))), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)",
      "paddingTop": "0.740741vh"
    }
  }, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "7.8125vw repeat(6,minmax(0,1fr)) 5.729167vw",
      "gap": "1.111111vh",
      "padding": "0.37037vh 0.740741vh",
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text("\n            "), React.createElement("span", {}, v.text("Día")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("Alarmas")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("PPA")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("Act. alim.")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("Corriente máx.")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("O₂ mín.")), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text("Temp. prom.")), React.createElement("span", {}, null), v.text("\n          ")), v.text("\n          "), (v.cRows || []).map((r, index163) => React.createElement(React.Fragment, {
    key: index163
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "7.8125vw repeat(6,minmax(0,1fr)) 5.729167vw",
      "gap": "1.111111vh",
      "alignItems": "center",
      "padding": "0.555556vh 0.740741vh",
      "borderRadius": "0.462963vh"
    },
    className: "scapp-full-hover"
  }, v.text("\n              "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "font": "500 1.203704vh 'IBM Plex Mono',monospace"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": r.c
    }
  }, null), v.text(r.date)), v.text("\n              "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.203704vh",
      "textAlign": "right",
      "color": r.alC
    }
  }, v.text(r.al)), v.text("\n              "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.203704vh",
      "textAlign": "right"
    }
  }, v.text(r.ppa)), v.text("\n              "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.203704vh",
      "textAlign": "right"
    }
  }, v.text(r.act)), v.text("\n              "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.203704vh",
      "textAlign": "right"
    }
  }, v.text(r.cur)), v.text("\n              "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.203704vh",
      "textAlign": "right"
    }
  }, v.text(r.oxy)), v.text("\n              "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.203704vh",
      "textAlign": "right"
    }
  }, v.text(r.temp)), v.text("\n              "), React.createElement("a", {
    "onClick": r.open,
    style: {
      "cursor": "pointer",
      "fontSize": "1.111111vh",
      "textAlign": "right"
    }
  }, v.text("Ver detalle ›")), v.text("\n            ")), v.text("\n          "))), v.text("\n        ")), v.text("\n      ")) : null;
}
